import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Divider from "@mui/material/Divider";
import "../0.styles.css";
import { Typography } from "@mui/material";
import { config, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useNavigate, Link as RouterLink } from "react-router-dom";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

function Login() {
  const [dialog, setDialog] = React.useState({ title: "", text: "" });
  const [openDialog, setOpenDialog] = React.useState(false);
  const [isSubmitting, setIsSubmitting] = React.useState(false);
  const navigate = useNavigate();
  const { login, user } = useAuth();

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    setIsSubmitting(true);
    instance
      .post("/auth/login", {
        email: info.email.value,
        password: info.password.value,
      })
      .then((res) => {
        login(res.data.user);
      })
      .catch((err) => {
        if (err.response?.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response?.data?.message });
        }
        setOpenDialog(true);
        setIsSubmitting(false);
      });
  };

  React.useEffect(() => {
    if (user?.id) {
      setIsSubmitting(false);
      navigate("/Homepage")
    }
  }, [user, navigate])

  return (
    <LoaderBox>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: { xs: "16px", sm: "24px" },
          marginTop: 8,
          borderRadius: 2,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginTop: 2,
            marginBottom: 2,
          }}
          component="form"
          onSubmit={handleSubmit}
        >
          <Box
            component="img"
            src={require("../imgs/icta.png")}
            alt="Logo ICTA"
            sx={{ width: 96, height: "auto", mb: 1 }}
          />
          <Typography component="h1" variant="h5">
            Ingreso
          </Typography>
          <Box noValidate sx={{ mt: 1, width: "100%" }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Correo electrónico"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <TextField
              margin="normal"
              required
              fullWidth
              name="password"
              label="Contraseña"
              type="password"
              id="password"
              autoComplete="current-password"
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              disabled={isSubmitting}
              sx={{ mt: 3, mb: 2, py: 1.2 }}
            >
              {isSubmitting ? "Iniciando sesión..." : "Ingresar"}
            </Button>
            <Grid container spacing={1}>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Link component={RouterLink} to="/RecuperarPassword">¿Olvidaste tu contraseña?</Link>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Typography variant="body2" color="text.secondary">
                  ¿No tienes cuenta?&nbsp;
                  <Link component={RouterLink} to="/Registro">Regístrate</Link>
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
        <Divider sx={{ mt: 1 }} />
        <Typography
          variant="caption"
          color="text.secondary"
          align="center"
          textAlign="center"
          sx={{ mt: 2, display: "block" }}
        >
          Versión {config.appVersion}
        </Typography>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
      />
    </LoaderBox>
  );
}

export { Login };
